import { combineReducers } from 'redux';
import placementList from './reducers';
import demandTab from '../DemandDetailsMaster/store/placement.demand.reducers';
import activityTab from '../Detail/DetailTabs/ActivityTab/store/placementDetail.activity.reducer';
import opSearch from '../Detail/DetailTabs/OpSearch/store/placementDetail.opSearch.reducer';
import supplyTab from '../Detail/DetailTabs/SupplyTab/store/placementDetail.supplyTab.reducers';
import tripTab from '../TripDetailsMaster/store/reducers';
import rateInfoTab from '../Detail/DetailTabs/RateInfo/store/placementDetail.rateInfo.reducer';

export default combineReducers({
  placementList,
  demandTab,
  activityTab,
  opSearch,
  supplyTab,
  tripTab,
  rateInfoTab,
});
